// extracted by mini-css-extract-plugin
module.exports = {"appCard":"_1ScA-vVcLQGKFyZ6W-X-c","description":"_3B6dzAFJWz8njxYUvIWCt4","title":"_1Mx9q53-V2RHKL37zEiswe"};